<template>
<div>
    <div v-if="resolved" class="row">
      <div class="col-md-2">
        <div :class="'card-'+emote.rarity+' card-small'">
          <img :src="'https://image.fnbr.co/emote/'+emote.id + '/icon.png'">
        </div>
      </div>
      <div class="col-md-5">
        <h1 class="title-text"><span>{{ emote.name }}</span></h1>
        <h2 class="desc-text"><span>{{ emote.description }}</span></h2>
        <h3 class="desc-text"><span>Price/Unlock: {{ emote.price }}</span></h3>
      </div>
      <div class="row videoRow">
        <iframe class="resp-iframe" id="ytplayer" type="text/html" allowfullscreen
          :src="'https://www.youtube.com/embed/'+emote.defaultVideo+'?autoplay=0&rel=0&origin=http://fortnite-emotes.com'"
          frameborder="0">
          </iframe>
      </div>
    </div>
    <div v-else>
      {{emote.name}}
    </div>
</div>
</template>

<script>
import axios from "axios"
import VueHead from 'vue-head'

export default {
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: 'Fortnite Emotes',
        complement: this.emote.name
      }
    }
  },
  data() {
    return {
      resolved: false,
      emote: {
        name: "Loading..."
      },
      videos: []
    };
  },

  created() {
    this.$store.dispatch("loadEmotes");
    this.findEmote();
  },

  computed: {
    emotes() {
      console.log("Emotes@Viewer");
      return this.$store.state.emotes;
    }
  },

  watch: {
    emotes: "findEmote"
  },

  methods: {
    findEmote: function() {
      if (this.resolved) return;
      //console.log("eagle: " + this.emotes.length);
      for (var i = 0; i < this.emotes.length; i++) {
        if (this.emotes[i].slug === this.$route.params.name) {
          console.log("Found match: " + this.emotes[i].name);
          this.emote = this.emotes[i];
          this.resolved = true;
        }
      }
    }
  }
};
</script>

<style scoped>
.row {
  justify-content: center; /* align horizontal */
}

.info {
  display: inline-flex;
  background-color: red;
}

img {
  vertical-align: middle;
  max-width: 100%;
  height: auto;
}

.resp-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

@media (min-width: 576px){
  .videoRow{
    width: 576px;
    height: 325px;
  }
}

@media (min-width: 768px){
  .videoRow{
    width: 768px;
    height: 434px;
  }
}

@media (min-width: 992px){
  .videoRow{
    width: 992px;
    height: 560px;
  }
}

@media (min-width: 1200px){
  .videoRow{
    width: 1200px;
    height: 668px;
  }
}

.title-text {
  font-family: "Luckiest Guy", Lato, Roboto, Calibri, Arial;
  text-transform: uppercase;
  font-size: 28px;
  text-align: left;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
  color: white;
  margin-left:3px;
  margin-right:3px;
}

  .desc-text {
  font-family: Lato, Roboto, Calibri, Arial;
  text-align: left;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
  color: white;
  margin-left:3px;
  margin-right:3px;
}
</style>


// WEBPACK FOOTER //
// src/components/EmoteViewer.vue